import fa from "element-ui/src/locale/lang/fa";

export {
  introduces
}

let introduces=[
  {
    title:'公司介绍',
    text: '谦泰生物科技有限公司，是一家致力于集产品调研、成分探究、生产监督与检验、产品宣传与推广、活动策划、线上下销售及售后服务于一体的战略性平台。我们在美妆日化领域拥有丰富的经验和专业知识，旨在为客户提供高质量、安全可靠的产品和服务。我们以客户满意度为首要目标，不断追求卓越，始终秉承着诚信、专业和创新的理念，致力于成为让每一位商业伙伴及消费者都可共同信赖的合作伙伴。',
    img:require('@/assets/swiper/swiper1.jpg'),
    isLeft: true,
    isWhite: false
  },
  {
    title: '公司业务',
    text:'欢迎来到伊美芝，您的日化美妆销售平台首选！伊美芝是一款专注于日化美妆产品的手机应用，致力于为您打造高品质的美丽购物平台。在伊美芝，您可足不出户尽情探索各类日化美妆产品。APP内商品丰富多样，无论您是追求自然清新还是奢华华丽，我们都能为您提供合适的选择。我们持续提供严格的产品筛选，保证商品的品质，只为确保您的的购物体验愉快无忧。下载伊美芝APP，开启您的美丽之旅，尽享优质美妆产品和无与伦比的购物乐趣！',
    img:require('@/assets/swiper/swiper4.jpg'),
    isLeft: false,
    isWhite: true
  },
//   {
//     title:'合作伙伴',
//     text:'上海亚明照明有限公司创始于1932年，是中国第一家民族照明企业，也是中国第一支白炽灯泡的制造者。作为新中国第一支股票飞乐音响的全资子公司，公司协同飞乐音响下兄弟公司北京申安投资集团、上海圣阑实业有限公司等，共同拥有上海、北京、河南、湖北、江苏、辽宁、黑龙江、山东、江西、四川等十大生产基地，产品覆盖道路照明、景观照明、工业照明、商业照明、家居照明及汽车照明领域。',
// img:require('@/assets/swiper/swiper3.jpg'),
//     isLeft: true,
//     isWhite: false
//   }
]
